export default __webpack_public_path__ + "img/abarth-logo.643c3ff6.png";